import { Task } from 'redux-saga';
import { cancel, fork, put, select, take, takeEvery, call } from 'redux-saga/effects';
import { getPathname, getRegion } from 'common/store/selectors';
import { fetchModel as fetchModelApi } from '../api/fetch-model';
import { fetchModel } from './actions';
import { ModelJson } from '../api/fetch-model.types';

function* fetchModelRequestSaga() {
  try {
    const pathname: string = yield select(getPathname);
    const region: string = yield select(getRegion);
    const model: ModelJson = yield call(fetchModelApi, { pathname, region });
    yield put(fetchModel.success(model));
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    yield put(fetchModel.failure(e));
  }
}

function* fetchModelFork() {
  const forked: Task = yield fork(fetchModelRequestSaga);
  yield take(fetchModel.cancel);
  yield cancel(forked);
}

export function* pageModelSaga() {
  yield takeEvery(fetchModel.request, fetchModelFork);
}
